import api from './api';

export interface PresentationSection {
    id: string;
    section_key: string;
    content: any;
}

class PresentationService {
    /**
     * Get all presentation content
     */
    async getAllContent(): Promise<PresentationSection[]> {
        try {
            const response = await api.get<PresentationSection[]>('/presentation');
            return response.data;
        } catch (error) {
            console.error('Error fetching presentation content:', error);
            throw error;
        }
    }

    /**
     * Get specific section content
     */
    async getSection(key: string): Promise<PresentationSection> {
        try {
            const response = await api.get<PresentationSection>(`/presentation/${key}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching presentation section ${key}:`, error);
            throw error;
        }
    }

    /**
     * Update section content
     */
    async updateSection(key: string, content: any): Promise<PresentationSection> {
        try {
            const response = await api.put<PresentationSection>(`/presentation/${key}`, { content });
            return response.data;
        } catch (error) {
            console.error(`Error updating presentation section ${key}:`, error);
            throw error;
        }
    }
}

export const presentationService = new PresentationService();
export default presentationService;
